import { UserRefreshTokenConfig } from '@/config';

export interface AuthUrlParams {
  code_challenge: string;
  state: string;
}

export const getRedirectUri = () => {
  return `${window.location.origin}/token/callback`;
};

export const constructAuthorizationUrl = ({ code_challenge, state }: AuthUrlParams): string => {
  const authorizationUrl = new URL(`https://${UserRefreshTokenConfig.domain}/authorize`);
  const params = new URLSearchParams({
    client_id: UserRefreshTokenConfig.clientId,
    response_type: 'code',
    code_challenge,
    code_challenge_method: 'S256',
    redirect_uri: getRedirectUri(),
    audience: UserRefreshTokenConfig.authorizationParams.audience,
    scope: UserRefreshTokenConfig.authorizationParams.scope,
    state,
  });

  return `${authorizationUrl}?${params}`;
};
